module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/cloud-saving.66a2e9bb.svg";